<template>
    <v-list dense class="kp-context-menu">
        <v-list-item v-if="!hidePreview" :href="getUrl(true)" target="tgk_preview">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-preview ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('preview') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{ name: 'address-edit', params: { id: record.id, backRoute: { route: $route } } }">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-pencil ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('edit') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!hideDuplicate" @click="$emit('duplicate-record', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-copy ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('duplicate') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$emit('delete-record', record)">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-trash ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('delete') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
        <v-list-item v-if="!hidePreview" @click="copyUrl">
            <v-list-item-icon>
                <v-icon>ic ic-20 ic-link ic-col-grey</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
                <v-list-item-title>{{ $t('copy_url') }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item>
    </v-list>
</template>

<script>
import { Address } from '@/models/Address';
import { frontendUrl, globalParam } from '@/helpers/globals';

export default {
    name: 'AddressContextMenu',

    props: {
        record: {
            type: Address,
            default: () => null,
        },
        hideDuplicate: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        hidePreview() {
            return globalParam('address.hide_preview');
        },
    },

    methods: {
        getUrl(preview = false) {
            return frontendUrl(`/kulturplatz/${this.record.id}`, preview ? { preview: 'enable' } : null);
        },

        async copyUrl() {
            try {
                await navigator.clipboard.writeText(this.getUrl());
            } catch (error) {
                this.$toast({ message: this.$t('could_not_copy_to_clipboard'), color: 'error' });
            }
        },
    },
};
</script>
